import { render, staticRenderFns } from "./VesselClientRole.vue?vue&type=template&id=45810753&scoped=true&"
import script from "./VesselClientRole.vue?vue&type=script&lang=js&"
export * from "./VesselClientRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45810753",
  null
  
)

export default component.exports